export const SET_TOKEN = 'set_token'

export const SET_PERMISSIONS = 'set_permissions'

